import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'batch-notification',
  templateUrl: './batch-notification.component.html',
  styleUrls: ['./batch-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchNotificationComponent {
  @Input() public isError: boolean;
  @Input() public isShowContactSupport: boolean;
  @Input() public isShowReload: boolean;
  @Input() public isShowClose: boolean;
  @Input() public header: string;
  @Input() public topHint: string;
  @Input() public hint: string;
  @Input() public downloadUrl: string;
  @Output() public close: EventEmitter<void> = new EventEmitter<void>();
  @Output() public reload: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('link', { static: false })
  public linkRef: ElementRef;

  constructor() {}

  public download(): void {
    this.linkRef.nativeElement.href = this.downloadUrl;
    this.linkRef.nativeElement.click();
  }
}
